const zhCN = {
    // Navbar
    nav: {
        home: '首页',
        features: '核心特性',
        download: 'App 下载',
        premium: '会员订阅',
        faq: '常见问题',
        downloadNow: '立即下载',
    },
    // Hero
    hero: {
        title: '食光机,',
        subtitle: '你的智能饮食管家',
        description: '食光机是一款结合 AI 视觉识别的健康追踪应用。拍下食物，瞬间估算热量与营养，帮你轻松记录每一餐，科学管理健康目标。',
        newFeature: '全新一代 AI 识别引擎现已上线，更准、更快、更懂中国胃！',
        appStoreDownload: 'App Store 下载',
        learnMore: '了解详情',
        iosSupport: '支持 iOS 16.0 及以上版本',
        appleEcosystem: '苹果生态集成',
        aiRecognition: 'AI 智能识别',
    },
    // Features (Home)
    features: {
        title: '拍个照，营养全知道',
        description: '得益于前沿的 AI 视觉大模型，食光机能精准识别超过 10,000+ 种中西式菜品。只需随手一拍，它就能自动估算食材重量、卡路里及核心营养素，让繁琐的饮食记录变得无比轻松。',
        photoRecognition: '拍照秒识',
        calorieEstimation: '热量估算',
        nutritionAnalysis: '营养分析',
        aiAdvisor: 'AI 营养顾问',
        accuracyNote: '* 识别准确率受拍摄角度与光线影响，数据仅供参考。',
    },
    // Downloads
    downloads: {
        title: '开始使用',
        mobileApp: '移动应用',
        ios: 'iOS',
        android: '安卓',
        directDownload: '直接下载 APK',
    },
    // FAQ
    faq: {
        title: '常见问题',
        subtitle: '这里提供了一些常见问题的解答。',
        contact: '遇到无法解决的问题？随时通过 App 内的反馈功能联系我们。',
        questions: [
            { question: "食光机是如何识别食物热量的？", answer: "食光机接入了先进的 AI 视觉大模型引擎，并结合了本地优化的中国食物营养数据库库。当您拍下食物照片时，AI 会分析食物种类与份量，然后自动匹配数据库为您计算热量与宏量营养素。" },
            { question: "游客模式和登录账号有什么区别？", answer: "游客模式可以体验基础的记录功能，但 AI 照片识别、AI 营养顾问等高级功能需要您通过 Apple ID 登录后方可无缝使用，以确保您的数据安全云端同步。" },
            { question: "食光机的识别准吗？", answer: "我们的 AI 引擎经过大量中西方菜品的训练，准确率在同类产品中处于领先水平。但由于拍摄角度、光线和隐藏食材（如重油重糖的调料）等因素，数据难免会有偏差，仅供健康参考。" },
            { question: "我的数据安全吗？", answer: "我们极为注重用户隐私。您的饮食记录与照片数据均保存在由 Supabase 提供支持的安全云端数据库中，我们绝不会将您的个人数据出售给第三方。" },
            { question: "如何取消会员订阅？", answer: "您可以随时在您的 iOS 设备的「设置」-「Apple ID」-「订阅」中管理或取消您的食光机会员订阅。" }
        ]
    },
    // Footer
    footer: {
        helpCenter: '帮助中心',
        sendFeedback: '发送反馈',
        contactEmail: '联系邮箱',
        product: '产品',
        iosDownload: 'iOS 下载',
        coreFeatures: '核心功能',
        subscription: '订阅计划',
        support: '支持',
        faq: '常见问题',
        changelog: '更新日志',
        contact: '联系我们',
        about: '关于',
        privacy: '隐私政策',
        terms: '服务条款',
        copyright: '© 2026 Andy Cao. All Rights Reserved.',
        wechat: '微信公众号',
        xiaohongshu: '小红书',
    },

    // --- Subpages ---

    // Terms Page
    termsPage: {
        title: "服务条款",
        date: "最后更新日期：2026年02月22日",
        toc: "目录",
        intro: "欢迎使用「食光机」！本《服务条款》（以下简称“本条款”）是您（在本条款中亦称“用户”）与应用开发者（以下简称“我们”）之间关于您下载、安装、注册、使用本应用的协议。在开始使用本应用之前，请您务必仔细阅读并充分理解本条款的全部内容。当您使用本应用，即表示您已阅读、理解并同意接受本条款的约束。如果您不同意本条款的任何内容，请立即停止使用本应用。",
        s1: "1. 接受条款",
        s1p1: "通过访问或使用本应用，您即确认您具有完全民事权利能力和民事行为能力，能够独立承担法律责任。若您不具备前述主体资格，请在法定监护人的陪同下阅读并同意本条款，否则我们有权随时暂停或终止向您提供服务。",
        s1p2: "我们保留随时修改本条款的权利。修改后的条款将在应用内或官方网站上公布。如果您在修改后继续使用本应用，即视为您接受修改后的条款。如果您不同意修改后的条款，您必须停止使用本应用。",
        s2: "2. 服务描述",
        s2p1: "「食光机」是一款旨在帮助用户记录和管理日常饮食、分析营养摄入的健康管理工具。本应用提供的主要功能包括但不限于：",
        s2i1: "AI 食物图像识别与热量/营养成分估算",
        s2i2: "用户饮食日志记录与管理",
        s2i3: "营养数据统计与分析报告",
        s2i4: "AI 营养顾问与健康建议（供参考）",
        s2p2: "请注意：本应用所提供的所有数据、分析和建议均基于算法模型及公开营养数据库生成，并非专业医疗建议。本应用不用于任何疾病的诊断、治疗、治愈或预防。在改变您的饮食习惯或制定健康计划之前，请务必咨询专业医生或注册营养师的意见。",
        s3: "3. 账号注册与安全",
        s3p1: "为了使用本应用的某些特定功能（如云端同步数据），您可能需要注册一个账号（例如使用 Apple ID 登录）。",
        s3i1: "您同意在注册时提供真实、准确、完整的个人信息，并在信息发生变化时及时更新。",
        s3i2: "您负责妥善保管您的账号凭证，并对在您的账号下发生的所有活动承担连带责任。",
        s3i3: "如您发现任何未经授权使用您账号的行为或任何其他安全漏洞，应立即通知我们。",
        s3i4: "我们不对因您未能遵守本条款产生的任何损失承担责任。",
        s3p2: "我们有权在合理怀疑您的账号存在异常活动、安全风险或违反本条款的情况下，暂停或终止您的账号访问权限。",
        s4: "4. 用户行为规范",
        s4p1: "在使用本应用的过程中，您同意不从事以下行为：",
        s4i1: "违反任何适用的法律、法规、政策或公序良俗；",
        s4i2: "侵害我们或任何第三方的合法权益，包括但不限于知识产权、隐私权、名誉权等；",
        s4i3: "利用本应用进行任何欺诈、商业兜售、发送垃圾信息或恶意软件的行为；",
        s4i4: "干扰、破坏本应用或与本应用连接的服务器、网络的正常运行；",
        s4i5: "未经许可，试图获取本应用、其他用户账号或相关系统的未授权访问；",
        s4i6: "使用任何自动手段（如爬虫、脚本等）获取本应用的数据或内容。",
        s4p2: "如您违反上述规定，我们有权视情节轻重采取包括但不限于警告、限制功能、暂停或永久封禁账号等措施，并保留进一步追究法律责任的权利。",
        s5: "5. 会员订阅与付费服务",
        s5p1: "本应用可能提供免费的“基础版”和付费的“Pro 会员版”。",
        s5p2: "订阅管理： Pro 会员可能采取按月或按年的自动续期订阅模式。订阅费用在您确认购买时通过您的应用商店账号（如 Apple App Store）收取。订阅会自动续期，除非您在当前订阅期结束前至少 24 小时关闭自动续期。您可以通过您的设备的应用商店账户设置管理或取消您的订阅。",
        s5p3: "退款政策： 除非适用法律另有规定，通过应用商店产生的费用由相关应用商店的政策管辖，退款由 Apple 处理且通常是不予退还的。",
        s6: "6. 知识产权",
        s6p1: "本应用及其所有内容、特征和功能（包括但不限于所有信息、软件、文本、显示、图像、视频和音频，以及其设计、选择和排列），均归应用开发者、其许可方或其他此类材料的提供者所有，并受版权、商标、专利、商业秘密和其他知识产权或所有权法律保护。",
        s6i1: "除非另有明文规定，您不得：保留应用代码（无论是目标代码还是源代码）；修改、复制或分发应用的内容；利用应用进行商业目的。",
        s6i2: "用户生成内容（UGC）： 您在使用本应用时上传、提交或拍摄的食物图片和数据仍属于您所有。通过向本应用提交上述内容，您授予我们一项非独家的、全球范围内的、免版税的许可，允许我们在为您提供服务和改进应用算法的范围内使用、存储和处理这些内容。",
        s6i3: "我们尊重知识产权。如您认为本应用的内容侵犯了您的知识产权，请通过本条款末尾的联系方式联系我们。",
        s6i4: "您同意我们有权在您涉嫌侵权的情况下，随时删除您的账号和发布的内容。",
        s6p2: "您同意我们在您未提出异议的情况下，将您提交的反馈和建议用于任何目的而无需向您支付任何报酬。",
        s6p3: "我们将您提交的关于应用的任何反馈和建议视为非机密信息和非专有信息，并不承担任何保密义务。",
        s6note: "⚠️ 警告：我们有权在收到有效的侵权通知后立即移除涉嫌侵权的内容，并可能终止重复侵权者的账号。",
        s7: "7. 隐私与数据保护",
        s7p1: "我们非常重视您的隐私。有关我们如何收集、使用、存储和保护您的个人信息，请查阅我们的《隐私政策》。《隐私政策》构成本条款不可分割的一部分。本应重点声明：",
        s7i1: "我们使用安全可靠的云服务提供商（Supabase）存储您的数据。",
        s7i2: "我们不会向任何未关联的第三方出售您的个人数据。",
        s7i3: "您可以随时要求注销账号并删除您的所有个人数据。",
        s7i4: "我们可能会收集匿名的、聚合的应用程序使用数据以帮助我们改进服务。",
        s7p2: "一旦您注销您的账号，与该账号相关的所有数据将无法恢复。请在操作前确保您已备份重要信息。",
        s8: "8. 免责声明与责任限制",
        s8p1: "我们尽力确保应用的正常运行与功能的准确性，但不对以下情形承担责任：",
        s8i1: "非医疗建议： 本应用估算的热量和营养数据仅供参考，由于个体差异及算法模型的局限性，不能保证 100% 准确。您不应依赖本应用提供的信息作为医疗诊断、治疗、改变饮食结构或用药的依据。对于因依赖本应用数据而造成的任何健康问题或后果，我们概不负责。",
        s8i2: "服务中断： 由于系统维护、升级、网络故障、不可抗力等原因导致的服务中断或延迟。",
        s8i3: "数据丢失： 尽管我们采取了安全措施，但我们不能绝对保证您的数据不会因为黑客攻击、系统故障等原因丢失。建议您自行备份重要数据。",
        s8i4: "第三方服务： 本应用可能包含链接至第三方网站或使用第三方服务（如 Supabase, RevenueCat）。我们对这些第三方服务的内容、隐私政策或做法不承担任何责任。",
        s8p2: "在适用法律允许的最大范围内，我们及我们的关联方、高级职员、雇员、代理人或许可方，不对您因使用或不能使用本应用而产生的任何间接、偶然、特殊、惩罚性或后果性损害（包括但不限于利润损失、数据丢失、商誉受损等）负责。",
        s9: "9. 条款终止",
        s9p1: "我们保留在任何时候以任何理由（包括但不限于违反本条款）终止或暂停您对本应用访问的权利，且无需事先通知。终止后，您使用本应用的权利将立即停止。",
        s9p2: "本条款中关于所有权规定、免责声明、赔偿和责任限制等在其性质上应继续有效的条款，在条款终止后将继续有效。",
        s10: "10. 适用法律与争议解决",
        s10p1: "本条款的订立、执行、解释及争议解决均适用中华人民共和国大陆地区法律。",
        s10p2: "因本条款引起或与本协议及您的应用使用产生的任何争议，双方应首先尝试友好协商解决。协商不成的，任何一方均有权将争议提交应用开发者所在地（或开发者指定的适当管辖区）有管辖权的人民法院诉讼解决。",
        s11: "11. 联系我们",
        s11p1: "如果您对本服务条款有任何疑问、意见或反馈，可以通过以下方式联系我们：",
        footer: "您使用本应用即代表您承认您已阅读、理解并同意受本条款和条件的约束。",
        back: "← 返回主页",
    },

    // Privacy Page
    privacyPage: {
        title: "隐私政策",
        date: "最后更新日期：2026年02月22日",
        intro: "欢迎使用「食光机」！我们（应用开发者）非常重视用户的隐私和个人信息保护。本《隐私政策》将向您说明我们在您使用本应用时，如何收集、使用、存储、共享和保护您的个人信息，以及您如何行使您的权利。",
        section1: "1. 我们收集什么信息",
        section1desc: "为了向您提供核心的饮食管理和 AI 识别服务，我们仅收集必要的信息：",
        item1title: "账户信息：",
        item1desc: "如果您选择注册账号（目前支持非强制性的游客模式和 Apple 登录），我们会生成一个唯一的用户标识符（User ID）。",
        item2title: "饮食与识别数据：",
        item2desc: "当您使用相机拍摄食物或手动记录时，我们会收集拍摄的图片内容（仅在拍照分析瞬间）、估算的热量、营养成分数据以及您的自定义记录，并将其保存在您的账户下。",
        item3title: "设备与使用数据：",
        item3desc: "为了改进服务和排查错误，我们可能会收集匿名的应用程序使用情况、崩溃日志、设备型号和操作系统版本。这些数据不含任何可识别您个人身份的信息。",
        section2: "2. 我们如何使用您的信息",
        section2desc1: "我们收集信息的首要目的是为您提供应用的核心功能：包括估算食物卡路里、生成营养分析报告和提供 AI 营养建议。",
        section2desc2: "我们绝不会将您的饮食数据、照片或账户信息出售、出租或交易给任何未关联的第三方广告商或数据中介机构。",
        section2desc3: "我们可能会使用去标识化和聚合的数据（无法识别特定个人）来改进我们的 AI 识别算法，使「食光机」能认出更多中国美食。",
        section3: "3. 信息的存储与安全",
        section3p1: "云端同步（针对登录用户）：您的饮食记录安全地存储在由 Supabase 提供支持的云端结构化数据库中。您的数据会经过加密处理。",
        section3p2: "我们采用行业标准的加密技术（如 HTTPS）在数据传输过程中保护您的信息，并实施严格的访问控制机制保护存储在云端的数据。",
        section31: "第三方数据处理者",
        section31p1: "我们依赖以下受信任的第三方服务提供商来运作我们的应用，它们可能会代表我们处理部分数据：",
        section31item1: "Supabase：提供核心的云端数据库和身份验证服务。您的账户和日志数据存储于此。",
        section31item2: "OpenAI / Claude 或其他 AI 大模型提供商：用于进行图像视觉分析。您拍摄的食物照片会被发送到这些 AI 引擎进行处理，并在分析完成后迅速丢弃，这些提供商承诺不会使用通过 API 传送的数据来训练他们的模型。",
        section31item3: "RevenueCat：如果您订阅了「食光机 Pro」会员，此服务用于管理您的订阅状态，处理应用内购买验证。",
        section31p2: "* 所有第三方服务均受其各自严格的隐私政策约束。",
        section31p3: "当由于并购、清算等重大变化导致我们需要转移您的个人数据时，我们会在转移之前向您发出通知，并确保您的数据受到同等水平的保护。",
        section4: "4. 您的权利",
        section4item1: "访问权与更正权：",
        section4item1desc: "您可以随时在应用内查看、修改您的饮食记录。",
        section4item2: "删除权（注销账户）：",
        section4item2desc: "我们提供完全被动的信息控制权。您可以随时在应用内请求「注销账户与清除数据」。一旦您确认注销，我们在云端数据库（Supabase）中与您账户相关联的所有饮食记录和个人信息将被永久删除，无法恢复。",
        section4item3: "撤回同意：",
        section4item3desc: "如果您在设备权限（如相机）中授予了权限，您可以随时在 iOS 系统的“设置”中撤回该授权。不授予相机权限将无法使用核心的拍照识别功能，但您仍可通过文字进行手动记录。",
        section5: "5. 未成年人的保护",
        section5desc: "「食光机」的主要用户群体为成年人。如果您是未成年人，建议您在父母或法定监护人的指导和同意下使用本应用。",
        section6: "6. 隐私政策的更新",
        section6desc: "随着产品功能的更新和法律法规的变化，我们可能会不时修订本政策。重大变更时，我们会在应用内发布显著通知以告知您。继续使用本应用将被视为您同意接受更新后的隐私政策。",
        section7: "7. 联系我们",
        section7desc: "如果您对本《隐私政策》有任何疑问、意见或需要行使您的权利，请通过以下方式与我们取得联系：",
        contactSite: "官方网站",
        footerNote: "通过使用我们的服务，您确认您已阅读并同意本隐私政策中的所有条款。",
        back: "← 返回主页",
    },

    // Features Page
    featuresPage: {
        title: "核心特性",
        subtitle: "探索食光机带来的智能健康管理体验",
        aiRecognition: "AI 视觉识别",
        f1Title: "拍照秒识万物，不再苦苦搜寻",
        f1Desc: "摒弃繁琐的手动搜索。食光机搭载了先进的多模态大模型，能精准识别各类中式炒菜、西式快餐、水果零食，甚至能估算食物的分量。",
        f1List1: "支持超过 10,000+ 种日常菜品识别",
        f1List2: "瞬间预估卡路里、碳水、蛋白质及脂肪",
        f1List3: "对「中国胃」特化训练，更懂你的日常饮食",
        f1List4: "支持手动微调分量，结果更精准",

        aiAdvisor: "AI 营养顾问",
        f2Title: "专属你的口袋营养师",
        f2Desc: "不知道下一餐该吃什么？食光机基于你的历史饮食记录，提供个性化的健康建议和营养小贴士。",
        f2List1: "针对饮食结构的分析与改善建议",
        f2List2: "智能生成下餐推荐建议",
        f2List3: "随时向 AI 询问任何关于营养健康的问题",
        f2List4: "像朋友一样的自然对话体验",

        cloudSync: "数据云同步",
        f3Title: "安全可靠的多端数据体验",
        f3Desc: "只要连接网络，你的饮食记录会在几秒内安全同步到云端。换手机也不怕数据丢失。",
        f3List1: "Apple ID 快捷安全登录",
        f3List2: "采用端到端加密保障你的隐私",
        f3List3: "所有设备间实时同步，记录永不丢失",
        f3List4: "支持离线浏览，网络恢复后自动上传",

        premium: "Pro 会员权益",
        f4Title: "解锁无限制的健康管理",
        f4Desc: "升级到 Pro 会员，体验没有限制的食光机。适合需要更专业、高频使用记录功能的您。",
        f4List1: "无限次 AI 食物视觉识别",
        f4List2: "无限次 AI 营养顾问对话",
        f4List3: "解锁深度的历史数据趋势分析",
        f4List4: "一键导出你的完整饮食报表 (CSV/Excel)",

        ctaTitle: "准备好开启更健康的饮食生活了吗？",
        ctaDesc: "今天就开始使用食光机，通过智能、科学的方式达成你的健康目标。一切从拍下一张食物照片开始。",
        downloadBtn: "立即下载 iOS 版",
        viewPlan: "查看订阅方案"
    },

    // Changelog Page
    changelogPage: {
        title: "更新日志",
        subtitle: "了解食光机的每一次成长与进步",
        latest: "最新版本",
        v100Date: "2026年3月1日",
        newFeatures: "新增功能",
        feature1: "全面升级：接入了最新的 GPT-4o 视觉模型引擎，食物识别准确率提升 40%！",
        feature2: "全新界面：重新设计了「今日饮食」主页卡片，UI 更加清爽现代",
        feature3: "Pro 功能：正式上线「数据导出」功能，一键生成精美饮食分析报告",
        feature4: "支持繁体中文与英文语言界面的无缝切换",
        feature5: "新增 Apple ID 快捷登录，保障数据安全云同步",
        improvements: "优化改进",
        improve1: "大幅提升了 App 冷启动速度和切换页面的流畅度",
        improve2: "优化了中式菜肴热量数据库的估算准确度",
        improve3: "重构了 AI 营养顾问对话模块的排版视觉体验",
        fixes: "错误修复",
        fix1: "修复了在网络较弱的环境下，拍照后可能一直转圈无法返回结果的问题",
        fix2: "修复了部分机型在暗黑模式下字体颜色显示异常的 Bug",
        fix3: "修复了跨时区旅行时饮食记录时间错乱的问题",

        beta: "Beta",
        v090Date: "2026年2月10日",
        beta1: "内测发布！首次将 AI 视觉识别技术融入日常饮食记录，发布基础版",
        beta2: "实装了核心的拍照识别食物卡路里功能",
        beta3: "本地化存储用户的饮食日记能力",
        beta4: "引入基于聊天的 AI 营养小助手",
        knownIssues: "已知问题",
        issue1: "暂不支持数据云端同步备份",
        issue2: "对于多种复杂混合的减脂餐盘可能一次无法识别所有内容",

        ctaTitle: "随时体验最新功能",
        ctaDesc: "我们将以两周为一个周期持续优化迭代食光机。",
        ctaButton: "前往 App Store 下载"
    },

    // Help Page
    helpPage: {
        title: "帮助中心",
        subtitle: "遇到问题？在这里找到答案",
        category1: "常见问题",
        category1desc: "解答关于食光机使用的常见问题",
        category2: "订阅与付款",
        category2desc: "关于会员订阅和支付的问题",
        category3: "功能介绍",
        category3desc: "了解食光机的核心功能和使用方法",
        category4: "更新日志",
        category4desc: "查看最新版本的功能更新",
        faqTitle: "热门常见问题",
        q1: "如何使用 AI 食物识别功能？",
        a1: "打开食光机 App，点击相机图标拍摄食物照片。AI 会自动识别食物种类并估算热量和营养成分。拍摄时建议光线充足，食物清晰可见以获得更准确的结果。",
        q2: "为什么识别结果有误差？",
        a2: "AI 食物识别基于图像分析，识别准确率受拍摄角度、光线条件、食物摆盘等因素影响。建议在充足光线下拍摄，保持食物完整可见。识别结果仅供参考，不作为医疗诊断依据。",
        q3: "如何切换语言？",
        a3: "在首页右上角点击语言按钮，可以切换简体中文、繁体中文和 English。语言设置会自动保存到您的账户中。",
        q4: "数据会自动同步吗？",
        a4: "登录 Apple ID 后，您的饮食记录会自动同步到云端。只需在同一 Apple ID 登录的不同设备上打开 App，即可查看历史数据。",
        q5: "如何联系客服？",
        a5: "您可以通过页面底部的\"发送反馈\"按钮联系我们，或者直接发送邮件至 andy.caoyueyang@gmail.com。我们会尽快回复您的问题。",
        noAnswer: "没有找到答案？",
        contactSubtitle: "我们的客服团队随时为您服务",
        sendEmail: "发送邮件",
        xiaohongshu: "关注小红书"
    },

    // Subscription Page
    subscriptionPage: {
        title: "会员订阅",
        subtitle: "选择适合您的订阅计划，解锁全部功能",
        free: "免费版",
        freePlan: "免费版",
        permanent: "/永久",
        freeDesc: "适合轻度使用",
        free1: "每天 4 次 AI 食物识别",
        free2: "每天 4 次 AI 对话问答",
        free3: "基础饮食记录",
        free4: "本地数据存储",
        free5: "营养深度分析",
        free6: "高级数据导出",
        free7: "个性化记忆识别",
        free8: "优先客服响应",
        freeUse: "免费使用",

        recommended: "推荐",
        mostPopular: "最受欢迎",
        monthlyPlan: "月卡会员",
        perMonth: "/月",
        monthlyDesc: "适合日常使用",
        monthly1: "无限次 AI 食物识别",
        monthly2: "无限次 AI 对话问答",
        monthly3: "完整饮食记录",
        monthly4: "云端数据同步",
        monthly5: "营养深度分析",
        monthly6: "高级数据导出 (CSV)",
        monthly7: "个性化记忆识别",
        monthly8: "优先客服响应",
        subscribeNow: "立即订阅",

        bestValue: "超值",
        annualPlan: "年卡会员",
        perYear: "/年",
        annualDesc: "相当于每月 ¥8.25",
        annual1: "无限次 AI 食物识别",
        annual2: "无限次 AI 对话问答",
        annual3: "完整饮食记录",
        annual4: "云端数据同步",
        annual5: "营养深度分析",
        annual6: "高级数据导出 (CSV/Excel)",
        annual7: "个性化记忆识别",
        annual8: "优先客服响应",
        annual9: "专属主题皮肤",

        faqTitle: "订阅常见问题",
        q1: "如何订阅会员？",
        a1: "点击上方的\"立即订阅\"按钮，会跳转到 App Store 下载页面。下载并安装食光机后，即可在应用内完成订阅。",
        q2: "免费版和付费版有什么区别？",
        a2: "免费版每天限制 4 次 AI 食物识别和 4 次 AI 对话。付费版无限制使用所有 AI 功能，包括营养深度分析、高级数据导出、个性化记忆识别等高级功能。",
        q3: "如何取消订阅？",
        a3: "您可以随时在 iOS 设备的「设置」-「Apple ID」-「订阅」中管理或取消食光机的会员订阅。",
        q4: "订阅后可以退款吗？",
        a4: "订阅退款由 Apple App Store 政策处理。如需退款，请联系 Apple 客服或访问 reportaproblem.apple.com。",
        note: "💡 订阅须知：订阅成功后，会员权益将在当前订阅周期内有效。订阅会自动续费，如需取消请在订阅到期前至少24小时关闭自动续费。"
    }
};

export default zhCN;
